import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";


import { FormlyView } from "../FormlyView";

export class AuthorisedProduct extends FormlyView {

    constructor(
        fieldDefinition: FieldDefinition,
        form: FormGroup,
        model: {},
    ) {
        super(form, 
            [...fieldDefinition.authorisedSenderFields,
             ...fieldDefinition.authorisationDetailFields,
             ...fieldDefinition.authorisedPresentationNameFields,
             ...fieldDefinition.commentFields], model);

            
    }
}